module.exports = __webpack_public_path__ + "img/main_media_slide4.00e6794d.jpg";